import React from "react";

import { Node, mergeAttributes } from "@tiptap/core";
import { NodeViewWrapper, ReactNodeViewRenderer } from "@tiptap/react";

import InlineCitation, { INLINE_CITATION_CLASS, getInlineCitationLabel } from "components/atoms/InlineCitation";

function ReferenceCitationNodeView({ extension, node }) {
    const attrs = node.attrs || {};
    const occurrenceId = attrs.occurrenceId;
    const citationLabel = extension.options.getCitationLabel?.(occurrenceId);

    return (
        <NodeViewWrapper as="span" contentEditable={false}>
            <InlineCitation
                data-occurrence-id={attrs.occurrenceId || undefined}
                data-reference-id={attrs.referenceId || undefined}
                data-reference-no={attrs.referenceNo || undefined}
                getReference={() => extension.options.getCitationReference?.(occurrenceId)}
                label={getInlineCitationLabel({ citationLabel, referenceNo: attrs.referenceNo })}
            />
        </NodeViewWrapper>
    );
}

const ReferenceCitation = Node.create({
    name: "referenceCitation",
    group: "inline",
    inline: true,
    atom: true,
    selectable: true,

    addOptions() {
        return {
            getCitationLabel: () => null,
            getCitationReference: () => null,
        };
    },

    addAttributes() {
        return {
            occurrenceId: {
                default: null,
                parseHTML: (element) => element.getAttribute("data-occurrence-id"),
                renderHTML: (attributes) => ({ "data-occurrence-id": attributes.occurrenceId }),
            },
            referenceId: {
                default: null,
                parseHTML: (element) => element.getAttribute("data-reference-id"),
                renderHTML: (attributes) => ({ "data-reference-id": attributes.referenceId }),
            },
            referenceNo: {
                default: null,
                parseHTML: (element) => element.getAttribute("data-reference-no"),
                renderHTML: (attributes) => ({ "data-reference-no": attributes.referenceNo }),
            },
        };
    },

    parseHTML() {
        return [{ tag: "span[data-note-reference-citation]" }];
    },

    renderHTML({ HTMLAttributes }) {
        const occurrenceId = HTMLAttributes["data-occurrence-id"] || HTMLAttributes.occurrenceId;
        const citationLabel = this.options.getCitationLabel?.(occurrenceId);
        const referenceNo = HTMLAttributes["data-reference-no"] || HTMLAttributes.referenceNo;
        return [
            "span",
            mergeAttributes(HTMLAttributes, {
                "data-note-reference-citation": "true",
                class: INLINE_CITATION_CLASS,
                contenteditable: "false",
            }),
            getInlineCitationLabel({ citationLabel, referenceNo }),
        ];
    },

    addNodeView() {
        return ReactNodeViewRenderer(ReferenceCitationNodeView);
    },
});

export default ReferenceCitation;
